import { Link as TiptapLink } from '@tiptap/extension-link'

export const Link = TiptapLink.configure({
    openOnClick: false,
    HTMLAttributes: {
        class: 'editor-link',
        rel: 'noopener noreferrer',
        target: '_blank',
    },
})